module.exports = __webpack_public_path__ + "static/media/arrow_left.6370c5e9.svg";